<div class="min-h-[100vh] min-w-[100vw] fixed flex items-center justify-center bg-black z-[10000] top-0 left-0">
  <div #lottieContainer style="width: 140px;"></div>
</div>
